import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import EventBus from "./event-bus";

class DeleteClass {
    func = () => {
        return new Promise(function(resolve, reject) {
            let resultData = {
                Data: {Result: {Info: {type : 1}}}
            }
            resolve(resultData)
        });
    };
    apiParamSet = {};
    keyName = 'wr_id';
    successType = 1;
    errorTypes = {};
    constructor(options) {
        if(!util.isEmpty(options.func)) {
            this.func = options.func;
        }
        if(!util.isEmpty(options.apiParamSet)) {
            this.apiParamSet = options.apiParamSet;
        }
        if(!util.isEmpty(options.keyName)) {
            this.keyName = options.keyName;
        }
        if(!util.isEmpty(options.successType)) {
            this.successType = options.successType;
        }
        if(!util.isEmpty(options.errorTypes)) {
            this.errorTypes = options.errorTypes;
        }
        if(!util.isEmpty(options.afterFunc)) {
            this.afterFunc = options.afterFunc;
        }
    }

    afterFunc = () => {};
    openErrorAlert(content) {
        /* Swal.fire({
             title: '',
             html: content,
             confirmButtonText: '확인',
             customClass:'alert_default',
             onClose: () => {

             }
         })*/
        EventBus.$emit('changeLoading', false);
        alertMixins.methods.errorAlert(content);
    }
    checkDeleteType(type) {
        if(type === this.successType) {
            return true;
        }
        return util.isEmpty(this.errorTypes[type]) ? "삭제에 실패하였습니다." : this.errorTypes[type];
    }

    runDelete(key, moreParams = {}, index=0) {
        let params = Object.assign({}, this.apiParamSet, moreParams);

        if (util.isArray(key)) {
            params[this.keyName] = key[index];
        } else {
            params[this.keyName] = key;
        }

        try {
            this.func(params).then(res => res.Data.Result).then(res => {
                let type = this.checkDeleteType(res.Info.Type);
                if(type === true) {
                    if(util.isArray(key)&& key.length > index+1) {
                        this.runDelete(key, moreParams, index+1)
                    }else {
                        this.afterFunc(key);
                    }
                }else{
                    this.openErrorAlert(type);
                }
            })
        }catch (e) {
            console.log(e);
        }

    }

    runExampleWordDelete(key, moreParams = {}, index=0) {

        let params = Object.assign({}, this.apiParamSet, moreParams);
        params[this.keyName] = key;
        try {
            this.func(params).then(res => res.Data.Result).then(res => {
                let type = this.checkDeleteType(res.Info.Type);
                if(type === true) {
                    this.afterFunc(key);
                }else{
                    this.openErrorAlert(type);
                }
            })
        }catch (e) {
            console.log(e);
        }

    }
}

export default DeleteClass;
